module.exports = __webpack_public_path__ + "static/media/1988_Population_totalRate.c1e379aa.png";